
export interface ResidenceDegree {
    serial: number;
    degreeNameAr: string;
    degreeNameEn: string;
    cashDegGlChartAccountCode: number;
    creditDegreeGlChartAccountCode: number;
    compDegreeGlChartAccountCode: number;
    cashMedGlChartAccountCode: number;
    creditMedGlChartAccountCode: number;
    compMedGlChartAccountCode: number;
    resType: number;
    limitByHour: number;
    limitType: number;
    limitCost: number;
    resBillItemCode: number;
    followUpBillItemCode: number;
    sterilizeBillItemCode: number;
    medFollowUpBillItemCode: number;
    bedCompanionBillItemCode: number;
    companionBillItem: number;
}
export interface ResidenceDegreeParms {
    serial?: number;
    priResidenceDegreeSerial?: number;
    regPatServiceSerial?:number;
    billPatResidenceSerial?:number
    contractId?: number;
    billItemCode?: number;
    visitSerial?: number;
    residenceType?: number;
    placeCode?: number;
    startDate?: Date;
    price?: number;
    netPrice?: number;
    patPrice?: number;
    sharedPrice?: number;
}
